import type { HTMLAttributes, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { getHandleActionKeyDown } from '@elfsight/widget-utils';
import { getAnimation } from '../../../../helpers';

export type DefaultButtonProps = PropsWithChildren &
  HTMLAttributes<HTMLDivElement> & {
    isCenter?: boolean;
    withoutMargin?: boolean;
    flexSize?: number;
    onClick?: () => void;
    _styles?: string;
  };

export function DefaultButton({
  children,
  isCenter = true,
  withoutMargin = false,
  flexSize = 24,
  onClick,
  ...props
}: DefaultButtonProps) {
  return (
    <IconComponent
      {...props}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={getHandleActionKeyDown(onClick)}
      _isCenter={isCenter}
      _withoutMargin={withoutMargin}
      _flexSize={flexSize}
    >
      {children}
    </IconComponent>
  );
}

export const IconComponent = styled.div<{
  _isCenter?: boolean;
  _withoutMargin?: boolean;
  _flexSize?: number;
}>`
  width: 24px;
  height: 24px;
  flex: 0 0 ${({ _flexSize }) => _flexSize}px;
  cursor: pointer;
  position: relative;
  margin-left: ${({ _withoutMargin }) => (_withoutMargin ? '0' : '16px')};
  ${({ _isCenter }) =>
    _isCenter &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  & svg {
    flex: 1;
  }

  &:before {
    width: 24px;
    height: 24px;
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    transition: ${getAnimation('opacity')};
    opacity: 0;
  }

  &:hover:before {
    opacity: 0;
  }

  &:first-child {
    margin-left: 0;
  }
`;
